export default __webpack_public_path__ + "static/media/basket.a4102988.svg";